export enum ESubscribersUrls {
  BASE_URL = 'workshop-subscribers',
  CITIES = 'cities',
  NOTIFY_ME = 'notify-me',
  EXPORT = 'export',
}
